<template>
    <el-form >
        <el-col :span="24">
            <el-table :data="form" style="width: 100%" class="tab-versionBind">
                <el-table-column fixed prop="id" label="ID" width="150">
                </el-table-column>
                <el-table-column prop="subject" label="学科" width="120">
                </el-table-column>
                <el-table-column label="绑定学科版本" width="300">
                    <template slot-scope="scope">
                            <span v-for="value in scope.row.bind_subject" :key="value" size="medium" class="xd-gap">
                                <el-tag>{{ value }}</el-tag>
                            </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="handleVersion(scope.row.id, true)" type="text" size="small">
                            绑定
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>

        <!-- 弹窗 -->
        <hr/>
        <el-dialog title="版本绑定" :visible.sync="dialogTableVisible" center :before-close='handleClose'
                   :append-to-body='true'>
            <el-table :data="dialogData" style="width:100%">
                <el-table-column label="学段" width="150">
                    <template slot-scope="scope">
                        <el-checkbox :key="scope.row.stage_id" v-model="scope.row.check_all"
                                     @change="handleCheckAllChange(scope.row.stage_id)">{{scope.row.stage_name}}
                        </el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="版本">
                    <template slot-scope="scope">
                        <el-checkbox-group style="text-align: left;" v-model="scope.row.check_group"
                                           @change="handleCheckedVersionsChange(scope.row)">
                            <el-checkbox v-if="scope.row.version_group" v-for="version in  scope.row.version_group"
                                         :label="version.versionId" :key="version.versionId">{{version.versionName}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleSubmitVersionBind" :loading="loading">确 定</el-button>
                </span>
        </el-dialog>
        <hr/>


    </el-form>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>

<script>
    import VersionService from "~/services/version";
    import CustomerService from "~/services/customer";
    import Config from "~/config/params";
    import CommonService from "~/services/common";

    export default {

        data() {
            return {
                currentSubject: 0,
                dialogTableVisible: false,
                dialogData: [],
                form: [],
                formLabelWidth: '120px',
                periods:[]
            };
        },
        async beforeMount() {

            this.form = (this.params.length > 0) ? this.params : await this.getVersionData();
            //let subjects = Config.getSubjects();
            let subject = {};
            CommonService.getAllSubjects().then(res=> {
                subject = Object.keys(res.data).map(key=>{
                    return res.data[key];
                });
                subject.map(item=>{

                    let subject = this.form.filter(s=>{
                        return s.id == item.subject_id
                    })

                    if(subject.length==0){
                        this.form.push({
                            id:item.subject_id ,
                            subject:item.subject_name,
                            bind_subject: [],
                            version: [],
                        });
                    }
                });


                this.handleVersion(this.currentSubject);
            });
        },
        mounted(){
            if(this.params.length == 0){
                this.setDefault();
            }
        },

        props: {
            customer_id:{
                required:true,
                type:Number
            },
            params: {
                type: Array,
                required: false
            }
        },
        methods: {
            async getVersionData() {
               // let subjects = Config.getSubjects();
                let versions = [];
                await CommonService.getAllSubjects().then(res=> {
                    let subjects = Object.keys(res.data).map(key=>{
                        return res.data[key];
                    });
                    subjects.map(item=>{
                        versions.push({
                            id:item.subject_id ,
                            subject:item.subject_name,
                            bind_subject: [],
                            version: [],
                        });
                    });
                });
                return versions;
            },

            handleSubmitVersionBind() {
                this.loading = true;
                this.form = this.form.map(item => {
                    if (item.id == this.currentSubject) {
                        let bind_xd = [];
                        this.dialogData.map(_item => {
                            if (_item.check_group.length > 0) {
                                bind_xd.push(_item.stage_name)
                            }
                        })
                        item.bind_subject = bind_xd;
                        this.dialogData = this.dialogData.map(item => {
                            let version = [];
                            if (item.check_all) {
                                item.version_group.map(item => {
                                    version.push(item.versionName);
                                })
                                item.version_bind = version;
                            } else if (item.check_group.length > 0) {
                                item.version_group.map(_item => {
                                    if (item.check_group.includes(_item.versionId)) {
                                        version.push(_item.versionName);
                                    }
                                })
                            }
                            item.version_bind_name = version;
                            item.version_bind = [];
                            item.version_group = [];
                            return item;
                        })
                        item.version = this.dialogData;
                    }
                    return item;
                });
                this.dialogTableVisible = false;
                this.$emit('handleSubmitVersionBind', this.form);
                this.loading = false;
            },

            handleCheckAllChange(value) {
                let index = this.dialogData.findIndex(item=>{
                    return item.stage_id == value;
                })
                if (this.dialogData[index].check_all == '') {
                    this.dialogData[index].check_all = false;
                    this.dialogData[index].check_group = [];

                } else {
                    this.dialogData[index].check_all = true;
                    let versionIds = [];
                    this.dialogData[index].version_group.forEach(item => {
                        versionIds.push(item.versionId);
                    });
                    this.dialogData[index].check_group = versionIds;
                }
            },
            handleCheckedVersionsChange(value) {
                let index = this.dialogData.findIndex(item=>{
                    return item.stage_id == value.stage_id;
                })
                let selectCount = this.dialogData[index].check_group.length;
                let groupCount = this.dialogData[index].version_group.length;
                if (selectCount < groupCount) {
                    this.dialogData[index].check_all = false;
                } else {
                    this.dialogData[index].check_all = true;
                }
            },
            handleVersion(chid) {
                if (!chid) return;
                let form = JSON.parse(JSON.stringify(this.form));
                let form_data = _.find(form, item => {
                    return item.id == chid;
                });
                this.currentSubject = chid;
                let init_data = [
                    {
                        stage_id: 1,
                        stage_name: '小学',
                        version_group: [],
                        check_all: false,
                        check_group: [],
                    }, {
                        stage_id: 2,
                        stage_name: '初中',
                        version_group: [],
                        check_all: false,
                        check_group: [],
                    }, {
                        stage_id: 3,
                        stage_name: '高中',
                        version_group: [],
                        check_all: false,
                        check_group: [],
                    }, {
                        stage_id: 4,
                        stage_name: '中职',
                        version_group: [],
                        check_all: false,
                        check_group: [],
                    }
                ];
                VersionService.getVersion({subjectId: chid}).then(res => {
                    if (res.code) {
                        console.log('请求失败');
                        return;
                    }
                    else {
                        this.dialogData = init_data.map(item => {
                            var cur_item = form_data.version.find(_item => {
                                return _item.stage_id == item.stage_id;
                            });
                            item.check_all = cur_item && cur_item.check_all || item.check_all;
                            if(res.data[item.stage_id] != null){
                                if (typeof res.data[item.stage_id]['data'] == 'undefined') {
                                    item.version_group = res.data[item.stage_id];
                                }
                            }

                            if (!Array.isArray(res.data[item.stage_id])) return item;
                            item.check_group = item.check_all ? res.data[item.stage_id].map(d => {
                                return d.versionId;
                            }) : (cur_item && cur_item.check_group || []);
                            return item;
                        });
                        this.dialogData = this.dialogData.filter(item=>{
                            return item.version_group.length>0;
                        })
                    }
                    this.dialogTableVisible = true
                });

            },

            /**
             * 关闭弹窗
             */
            handleClose() {
                this.dialogTableVisible = false;
            },


            /**
             * 默认设置选中
             */
            setDefault() {
                CustomerService.getInfo(this.customer_id).then(async (res) => {
                    if (res.code) return false;
                    let periods = res.data['periods'];
                    this.periods = periods;
                    let promise_data = [];
                    this.form = await this.getVersionData();
                    this.form.map(item => {
                        promise_data.push(this.getVersion(item.id, this.form,periods));
                    });
                    Promise.all(promise_data).then((result) => {
                         this.$emit('handleSubmitVersionBind', result);
                    });

                })
            },
            getVersion(chid, form,periods) {
                    let init_data = [
                        {
                            stage_id: 1,
                            stage_name: '小学',
                            version_group: [],
                            check_all: false,
                            check_group: [],
                        }, {
                            stage_id: 2,
                            stage_name: '初中',
                            version_group: [],
                            check_all: false,
                            check_group: [],
                        }, {
                            stage_id: 3,
                            stage_name: '高中',
                            version_group: [],
                            check_all: false,
                            check_group: [],
                        }, {
                            stage_id: 4,
                            stage_name: '中职',
                            version_group: [],
                            check_all: false,
                            check_group: [],
                        }
                    ];
                    init_data = init_data.filter(item=>{
                        return this.periods.includes(item.stage_id);
                    })
                    return VersionService.getVersion({subjectId: chid}).then(res => {
                        if (res.code) {
                            return Promise.reject('请求失败');
                        }
                        let need_chid = form.find(item => item.id == chid );
                        let version = init_data.map(item => {
                            if(!res.data || !res.data[item.stage_id] || res.data[item.stage_id].length == 0){
                                return [];
                            }
                            if(periods.includes(item.stage_id)){
                                need_chid.bind_subject.push(item.stage_name);
                            }
                            item.check_all = true;
                            item.check_group = res.data[item.stage_id].map(d => {
                                return d.versionId;
                            });
                            item.version_bind_name = res.data[item.stage_id].map(d => {
                                return d.versionName;
                            });
                            return item;
                        })
                        version = version.filter(item=>{
                            return item != null;
                        })

                        need_chid.version = version;
                        return need_chid;
                    });


            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/jiaoben/versionBind.vue